// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__3oIlw","title":"InfoRow_title__1FY1T"};